
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accelerate/2021/program",
      function () {
        return require("private-next-pages/accelerate/2021/program/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accelerate/2021/program"])
      });
    }
  